/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingItemsDialog extends _Ext.ItemEditorDialog<SKURepricingItemsRow> {
        protected getFormKey() { return SKURepricingItemsForm.formKey; }
        protected getLocalTextPrefix() { return SKURepricingItemsRow.localTextPrefix; }
        protected getDeletePermission() { return SKURepricingItemsRow.deletePermission; }
        protected getInsertPermission() { return SKURepricingItemsRow.insertPermission; }
        protected getUpdatePermission() { return SKURepricingItemsRow.updatePermission; }

        public form = new SKURepricingItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        public LotNo: any;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            //Make grid full width
            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.BOMDetails);
            //Hide Image and BOM Details
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName); 
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.StoneAmount);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.UnitCost);
            q.setTextRightAlign(this.form.UnitLabour);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.MF);
            q.setTextRightAlign(this.form.MFAmount);

            this.form.StampId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });
            this.form.Hallmark.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });
            this.form.SuperTypeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.MF.changeSelect2(e => {
                this.form.MFAmount.value = this.form.GrossAmount.value / this.form.MF.value;
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            //Cascade Code
            //let prior = $(".ui-dialog").eq(-2);
            //if (prior.length > 0) {
            //    $(document).one("dialogopen", (e) => {
            //        this.element.dialog().dialog('option', 'position', { my: 'left top', at: 'left+24 top+24', of: prior[0] });
            //    })
            //}

            if (this.entity.HasBom == false) {
                q.hideEditorTab(this.form.ImageName);
                q.hideEditorTab(this.form.BOMDetails);
                
            }
            let changeAttributes = q.ToBool(TabAurous.GetConfigValue(1034));  
            if (changeAttributes) {
                q.showAndEnableField(this.form.StampId);
                q.showAndEnableField(this.form.Hallmark);
                q.showAndEnableField(this.form.SuperTypeId);
            } else {
                q.showAndDisableField(this.form.StampId);
                q.showAndDisableField(this.form.Hallmark);
                q.showAndDisableField(this.form.SuperTypeId);
            }


        }

        getItem() {
            return this.getSaveEntity();
        }

        CalculateTotals() {
            if (this.form.HasBom.value) {
                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                var labrate = 0.00; var wstper = 0; var wstwt = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }
                    rate += k.BomAmount;
                }

                var LAmount = 0;
                var Wst = 0;
                if (this.form.LaborDetails.getItems().length > 0)
                    for (var l of this.form.LaborDetails.getItems()) {
                        if (l.ProcessName == "Wastage")
                            Wst += l.WstPer;

                        LAmount += l.LabourAmount;
                    }
                this.form.UnitLabour.value = LAmount;
                this.form.WstPer.value = Wst;
                this.form.WstWt.value = this.form.Weight.value * Wst;

                this.form.NetWeight.value = Wt;
                this.form.OtherPieces.value = othrpcs || 0;
                this.form.StonePieces.value = clrpcs || 0;
                this.form.StoneWeight.value = gms;
                this.form.DiamondPieces.value = diapcs || 0;
                this.form.DiamondWeight.value = cts || 0;
                this.form.OtherWeight.value = 0;

                if (cts > 0)
                    this.form.Weight.value = Wt + gms + (cts / 5);
                else
                    this.form.Weight.value = Wt + gms;
                this.form.UnitRate.value = rate / this.form.Pieces.value;
                this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                if (this.form.Pieces.value != null) {
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                }
            }
            else if (!this.form.HasBom.value && this.entity.ItemTypeId == 101) {
                this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                this.form.NetWeight.value = this.entity.NetWeight;
                this.form.UnitRate.value = this.entity.UnitRate;
                var LAmount = 0;
                var Wst = 0;
                if (this.form.LaborDetails.getItems().length > 0)
                    for (var l of this.form.LaborDetails.getItems()) {
                        if (l.ProcessName == "Wastage")
                            Wst += l.WstPer;

                        LAmount += l.LabourAmount;
                    }
                this.form.UnitLabour.value = LAmount;

                this.form.NetAmount.value = (this.entity.UnitRate * this.entity.Weight) + this.form.UnitLabour.value;
                this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;

            }

        }

    }
}